/**
 * Action ids for the Trigger Candid dropdown on the Candid Upload tab.
 */
export enum CandidUploadDropdownAction {
  DocumentUpload = "documentUpload",
  AuthorizationInformation = "authorizationInformation",
  AuthNotes = "authNotes",
}
